module.exports = __webpack_public_path__ + "img/laptop2.eaa1aa4a.jpg";